import { render, staticRenderFns } from "./TrainersCrud.vue?vue&type=template&id=932878b2&"
import script from "./TrainersCrud.vue?vue&type=script&lang=js&"
export * from "./TrainersCrud.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports